export const TRANFERS_REFRESH_URLS = {
  TRANSFER_START: 'transfers/entities?',
  INBOUND_TRANSFER_DETAILS: 'channel_inbound_transfers',
  STANDING_TRANSFER_DETAILS: 'channel_account_standing_orders',
  ONE_OFF_TRANSFERS_DETAILS: 'one-off_transfers',
  CHANNEL_PAYMENT_DATA: 'channel_payment_data',
  BENEFICIARY_DETAILS: 'channel_payees/',
};

export const CRYPTO_REFRESH_URLS = {

};